const STORAGE_KEY = "muzone.auth.postLoginRedirect.v1";
const REDIRECT_TTL_MS = 10 * 60 * 1000;

const hasWindow = () => typeof window !== "undefined";

const hasControlCharacter = (value) => {
    for (let index = 0; index < value.length; index += 1) {
        const code = value.charCodeAt(index);
        if (code <= 0x1f || code === 0x7f) {
            return true;
        }
    }
    return false;
};

export const sanitizePostLoginRedirect = (value) => {
    if (typeof value !== "string") {
        return "/";
    }

    const trimmed = value.trim();
    if (
        !trimmed.startsWith("/")
        || trimmed.startsWith("//")
        || trimmed.includes("\\")
        || hasControlCharacter(trimmed)
    ) {
        return "/";
    }

    return trimmed;
};

export const clearStoredPostLoginRedirect = () => {
    if (!hasWindow()) {
        return;
    }

    try {
        window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {
        // Ignore storage failures. The redirect is a convenience, not auth state.
    }
};

export const persistPostLoginRedirect = (value, now = Date.now()) => {
    const redirect = sanitizePostLoginRedirect(value);
    if (redirect === "/") {
        clearStoredPostLoginRedirect();
        return redirect;
    }

    if (!hasWindow()) {
        return redirect;
    }

    try {
        window.sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
                redirect,
                expiresAt: now + REDIRECT_TTL_MS,
            })
        );
    } catch (_) {
        // Ignore storage failures and let the callback use the default route.
    }

    return redirect;
};

export const consumePostLoginRedirect = (now = Date.now()) => {
    if (!hasWindow()) {
        return "/";
    }

    try {
        const raw = window.sessionStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return "/";
        }

        const parsed = JSON.parse(raw);
        const redirect = sanitizePostLoginRedirect(parsed?.redirect);
        const expiresAt = Number(parsed?.expiresAt);
        if (redirect === "/" || !Number.isFinite(expiresAt) || expiresAt <= now) {
            return "/";
        }

        return redirect;
    } catch (_) {
        return "/";
    } finally {
        clearStoredPostLoginRedirect();
    }
};
